export const orderDetails = {
    header: 'Track Order',
    quote: 'Quote',
    subHeader: 'Details',
    hasBeenShipped: 'Dieser Auftrag wurde bereits abgeschlossen',
    orderSummary: 'Order Summary',
    labels: {
        shippingMethod: 'Shipping',
        orderNumber: 'Order Number',
        quoteNumber: 'Quote number',
        createdAt: 'Ordered',
        quoteCreatedAt: 'Request',
        orderStatus: 'Order status',
        productionTime: 'Production time',
        deliveryTime: 'expected delivery Time',
        deliveryTimeShort: 'exp. delivery Time',
        deliveryAndProductionTime: 'exp. delivery',
        shippingAddress: 'Shipping address',
        billingAddress: 'Billing address',
        name: 'Name',
        email: 'Email',
        address: 'Address',
        city: 'City',
        country: 'Country',
        paymentMethod: 'Payment Methods',
        items: 'items',
        summary: 'Summary',
        positionPrice: 'Position price',
        shippingPrice: 'Shipping costs',
        amountTotal: 'Amount Total',
        cartSum: 'Sum',
    },
    businessDays: '0 business days | 1 business day | {n} business days',
    regularDays: '0 days | 1 day | {n} days ',
    actions: {
        reOrder: 'Re Order',
        payNow: 'Pay now',
        orderNow: 'Order now',
    },
    reOrderModal: {
        headline: 'Would you like to commission order {orderNumber} again?',
        nItems: '0 Parts | One Parts | {n} Parts',
    },
};
